import Vue from 'vue';

/**
 * 确定插件--------------开始
 */

import ConfirmVue from '@/components/Confirm.vue';

let ConfirmCons = Vue.extend(ConfirmVue);

let ConfirmIns = null;

const ConfirmPlugin = function(title, content, type) {
    /*
    type: is {type:'info',hideButton:'cancel'|'OK'} string define witch button to show
    */
  if (!ConfirmIns) {
    ConfirmIns = new ConfirmCons({
      el: document.createElement('div'),
      propsData: {}
    });
    document.body.appendChild(ConfirmIns.$el);
  }
  return new Promise((resolve, reject) => {
    ConfirmIns.showDialog(title, content, type);
    ConfirmIns.$on('confirm', () => {
        resolve(true);
    });
    ConfirmIns.$on('cancel', () => {
        reject(false);
    });
  })
};

/**
*Confirm plugin -------------- End
*/
/**
*Loading plugin ------------- Start
*/

import LoadingVue from '@/components/Loading.vue';

let LoadingCons = Vue.extend(LoadingVue);

let LoadingIns = null;

const LoadingPlugin = function(maskEL, title) {
    if (!LoadingIns) {
        LoadingIns = new LoadingCons({
            el: document.createElement('div'),
            propsData: {}
        });
        document.body.appendChild(LoadingIns.$el);
    }
    if(maskEL) {
        LoadingIns.show(title);
    } else {
        LoadingIns.close();
    }
};

/**
*Loading plugin ------------- End
*/
/**
*Information Toast Plugin ------------- Start
*/

import MessageVue from '@/components/Message.vue'

let MessageCons = Vue.extend(MessageVue);

const instances = [];
let instance = null;


const MessagePlugin = function(options) {
    instance = new MessageCons({
        data: {
            onClose: MessagePlugin.close
        },
        el: document.createElement('div'),
        propsData: {
            ...options
        }
    })
    instance.$mount();
    document.body.appendChild(instance.$el);
    let top = 20;
    if(instances.length >= 3) {
        instances[0].close(instances[0].top);
    }
    instances.forEach(item => {
        top += 66;
    });
    instance.visible = true;
    instance.top = top;
    instance.$el.style.zIndex = 100;
    instances.push(instance);
  return instance;
}

let temArr = ['success', 'info', 'error'];
temArr.forEach(i => {
    MessagePlugin[i] = (options, parma, duration) => {
        return MessagePlugin({
            type: i,
            duration,
            message: Vue.prototype.$tran(options, parma)
        });
    }
})

MessagePlugin.close = (top) => {
    let temIndex = null;
    instances.forEach((i, index) => {
        if(i.top === top) {
            temIndex = index;
        }
    })
    instances.splice(temIndex, 1);
    for (let i = temIndex; i < instances.length; i++) {
        if(instances[i].top >= 66) {
            instances[i].top = instances[i].top - 66;
        } else {
            instances[i].top = instances[i].top;
        }
    }
}

/**
*Information Toast Plugin ------------- End
*/
/**
*Mandatory password modification pop-up plugin --------------- Start
*/

import UpdatePasswordDialog from '@/components/UpdatePasswordDialog.vue';

let UpdatePasswordDialogCons = Vue.extend(UpdatePasswordDialog);

let UpdatePasswordDialogIns = null;

/**
 * @param {*} Whether to display the forced password update pop-up window with default false
 * If it is actively closed, it is necessary to ensure that the current token is set to empty
 */
const UpdatePasswordPlugin = function(isShowCancel) {
  if (!UpdatePasswordDialogIns) {
    UpdatePasswordDialogIns = new UpdatePasswordDialogCons({
      el: document.createElement('div'),
      propsData: {}
    });
    document.body.appendChild(UpdatePasswordDialogIns.$el);
  }
  if(isShowCancel) {
    UpdatePasswordDialogIns.showDialog();
  } else {
    UpdatePasswordDialogIns.closeDialog();
  }
};

/**
 * Mandatory password change pop-up plugin ----------------- End
 */


export {
    ConfirmPlugin as Confirm,
    LoadingPlugin as Loading,
    MessagePlugin as Message,
    UpdatePasswordPlugin as UpdatePassword
};